import { useState } from "react";

const useNewToggle = (): [boolean, () => void, (val: boolean) => void] => {
  const [value, setValue] = useState(false);

  const toggle = (): void => {
    setValue((prev) => !prev);
  };

  return [value, toggle, setValue];
};

export default useNewToggle;
